var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21582 8.49967H7.02634M7.02634 8.49967H29.5105M7.02634 8.49967V28.333C7.02634 29.0845 7.32244 29.8051 7.84952 30.3365C8.37659 30.8678 9.09145 31.1663 9.83685 31.1663H23.8894C24.6348 31.1663 25.3497 30.8678 25.8768 30.3365C26.4038 29.8051 26.6999 29.0845 26.6999 28.333V8.49967M11.2421 8.49967V5.66634C11.2421 4.91489 11.5382 4.19422 12.0653 3.66287C12.5924 3.13152 13.3072 2.83301 14.0526 2.83301H19.6737C20.419 2.83301 21.1339 3.13152 21.661 3.66287C22.1881 4.19422 22.4842 4.91489 22.4842 5.66634V8.49967M14.0526 15.583V24.083M19.6737 15.583V24.083",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteQuestion);
export default __webpack_public_path__ + "static/media/delete-question.0ef8668751780e2bf2cc681f57c0c141.svg";
export { ForwardRef as ReactComponent };